import { z } from 'zod';
import { cannabisConsumptionQuestionnaireReqDto } from '../cannabis-consumption-questionnaire';
import { sf12QuestionnaireReqDto } from '../sf12-questionnaire';
import {
  CheckListId,
  CheckListItemType,
  questionnaireResultField,
} from '../checklist';

const commonFields = z.object({
  type: z.nativeEnum(CheckListItemType),
  done: z.boolean(),
});

export const repeatedCheckListData = z.object({
  [CheckListId.CannabisConsumptionQuestionnaire]: z
    .object({
      [questionnaireResultField]:
        cannabisConsumptionQuestionnaireReqDto.optional(),
    })
    .merge(commonFields),
  [CheckListId.SF12Questionnaire]: z
    .object({
      [questionnaireResultField]: sf12QuestionnaireReqDto.optional().nullable(),
    })
    .merge(commonFields),
});
export type RepeatedCheckListDataSchema = z.infer<typeof repeatedCheckListData>;

export const storeRepeatedChecklistReqDto = z.object({
  data: repeatedCheckListData.optional(),
});
export type StoreRepeatedChecklistReqDto = z.infer<
  typeof storeRepeatedChecklistReqDto
>;
